<div class="ui tab" [class.active]="configuration.selected" [class.loading]="configuration.selected && isLoading" [hidden]="!configuration.selected" data-tab="configuration.title">
  <ng-template viewContainer #componentTemplate></ng-template>
</div>

